<script setup>
import { computed } from 'vue';
import DocumentsHeader from '../DocumentsHeader/DocumentsHeader.vue';
import PaginationFooter from 'dashboard/components-next/pagination/PaginationFooter.vue';

const props = defineProps({
  searchValue: { type: String, default: '' },
  headerTitle: { type: String, required: true },
  filterOptions: { type: Array, default: () => [] },
  activeFilter: { type: String, default: 'all' },
  currentPage: { type: Number, default: 1 },
  totalItems: { type: Number, default: 0 },
  itemsPerPage: { type: Number, default: 25 },
  showSearch: { type: Boolean, default: true },
  showManageTypes: { type: Boolean, default: false },
});

defineEmits(['search', 'add', 'manageTypes', 'pageChange', 'update:filter']);

const hasPagination = computed(() => props.totalItems > props.itemsPerPage);
</script>

<template>
  <div class="flex flex-col min-h-full">
    <DocumentsHeader
      :search-value="searchValue"
      :header-title="headerTitle"
      :filter-options="filterOptions"
      :active-filter="activeFilter"
      :show-search="showSearch"
      :show-manage-types="showManageTypes"
      @search="$emit('search', $event)"
      @add="$emit('add')"
      @manage-types="$emit('manageTypes')"
      @update:filter="$emit('update:filter', $event)"
    />

    <main class="flex-1 overflow-y-auto">
      <div class="w-full mx-auto max-w-[60rem]">
        <slot name="empty" />
        <slot />
      </div>
    </main>

    <footer
      v-if="hasPagination"
      class="flex items-center justify-end px-6 py-4 border-t border-n-slate-5"
    >
      <PaginationFooter
        :current-page="currentPage"
        :total-items="totalItems"
        :items-per-page="itemsPerPage"
        @update:current-page="$emit('pageChange', $event)"
      />
    </footer>
  </div>
</template>
